import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}movimiento_diashoras`);
  return response;
};

const getFilter = async (tipo_periodo, anio, num_periodo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}movimiento_diashoras/${tipo_periodo}/${anio}/${num_periodo}`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}movimiento_diashoras/get/list`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}movimiento_diashoras/${id}`);
  return response;
};
const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}movimiento_diashoras`, payload);
  return response;
};

const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}movimiento_diashoras`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}movimiento_diashoras/${id}`);
  return response;
};

export { getAll, getFilter, getList, getById, insert, update, drop };

// Funciones para importación de datos desde archivo CSV/Excel

const importBulk = async (file, periodo_id, anio, num_periodo, force_save = false) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('periodo_id', periodo_id);
  formData.append('anio', anio);
  formData.append('num_periodo', num_periodo);
  formData.append('force_save', force_save ? 1 : 0);

  const response = await fetch(`${process.env.REACT_APP_SERVER}movimiento_diashoras/import`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    body: formData,
  });

  return await response.json();
};

const importBulkConfirm = async (periodo_id, anio, num_periodo, cached_records) => {
  const payload = {
    periodo_id,
    anio,
    num_periodo,
    cached_records,
  };
  const response = await post(`${process.env.REACT_APP_SERVER}movimiento_diashoras/import/confirm`, payload);
  return response;
};

export { importBulk, importBulkConfirm };
